// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfs_a"};